import script from "./InspectorShadow.vue?vue&type=script&setup=true&lang=js"
export * from "./InspectorShadow.vue?vue&type=script&setup=true&lang=js"

import "./InspectorShadow.vue?vue&type=style&index=0&id=58c0c44c&lang=scss"

const __exports__ = script;

export default __exports__